const nextRoutesNurse = [
  "chief-complaint",
  "arrival-info",
  "actions",
  "vitals",
  "medical-hx",
  "assessments",
  "order-form",
  "iv-and-medications",
  "treatments",
  "radiology",
  "labs",
  "ekg",
  "procedures",
  "progress",
  "order-history",
  "supplies",
  "disposition",
];

const nextRoutesProvider = [
  "arrival-info",
  "medical-hx",
  "vitals",
  "order-history",
  "hpi",
  "ros",
  "physical-exam",
  "order-form",
  "iv-and-medications",
  "treatments",
  "radiology",
  "labs",
  "ekg",
  "procedures",
  "progress",
  "mdm",
  "clinical-impression",
  "disposition",
  "supplies",
  "procedural-sedation-note",
];

export { nextRoutesNurse, nextRoutesProvider };
